var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLockClosed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 160 160",
    width: 160,
    height: 160,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 5,
    d: "M80 157.5C37.14 157.5 2.5 122.86 2.5 80C2.5 37.14 37.14 2.5 80 2.5C122.86 2.5 157.5 37.14 157.5 80C157.5 122.86 122.86 157.5 80 157.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "none",
    fillRule: "evenodd",
    d: "M115 74.25L115 126L46 126L46 74.25L57.5 74.25L57.5 57.45C57.5 54.21 58.08 51.18 59.25 48.33C60.42 45.48 62.04 43 64.1 40.87C66.17 38.75 68.6 37.07 71.38 35.84C74.17 34.61 77.21 34 80.5 34C83.76 34 86.79 34.61 89.57 35.84C92.36 37.07 94.8 38.75 96.9 40.87C98.99 43 100.61 45.48 101.75 48.33C102.89 51.18 103.47 54.21 103.5 57.45L103.5 74.25L115 74.25ZM63.25 74.25L97.75 74.25L97.75 57.45C97.75 55.02 97.32 52.75 96.45 50.62C95.58 48.49 94.38 46.61 92.85 44.96C91.33 43.31 89.5 42.04 87.37 41.14C85.25 40.24 82.96 39.78 80.5 39.75C78.04 39.75 75.77 40.21 73.67 41.14C71.58 42.07 69.75 43.34 68.19 44.96C66.63 46.58 65.42 48.45 64.55 50.58C63.68 52.7 63.25 54.99 63.25 57.45L63.25 74.25ZM109.25 80L51.75 80L51.75 120.25L109.25 120.25L109.25 80Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockClosed);
export default __webpack_public_path__ + "static/media/lock-closed.7b3786a2cd3234d2161fcd45a59196e2.svg";
export { ForwardRef as ReactComponent };